import { createFileRoute } from '@tanstack/react-router';

import { AboutPageContent } from '@/components/layout/pages/about-page';
import { staticPageHead } from '@/config/seo-head';

export const Route = createFileRoute('/about')({
  head: () => staticPageHead('/about'),
  component: AboutPageContent,
});
